import { AppContext } from 'App'
import { Ad, ProductList, FeaturedCategories, QuickDelivery, CarouselComp } from 'components'
import { useContext } from 'react'

interface Props {
};

export function Home(props: Props) {
    const { cat_sub_cat } = useContext(AppContext)

    return (
        <div className="home">
            <div className="max-width p-x mob-py-07 d-flex">
                <CarouselComp />
            </div>
            <Ad />
            <FeaturedCategories cat_sub_cat={cat_sub_cat} />
            <ProductList start={0} title='Popular Products for Daily Shopping' body='See all our popular products in this week. You can choose your daily needs products from this list and get some special offer with free shipping.' />
            <QuickDelivery />
            <ProductList discount start={7} title='Latest Discounted Products' body='See Our latest discounted products below. Choose your daily needs from here and get a special discount with free shipping.' />
        </div>
    )
}
